/**
 * @Description 单个商圈
 */
import { FC, useMemo } from 'react';
import { Col, Row } from 'antd';
import { beautifyTheLowHighObject, isNotEmpty, isNotEmptyAny, replaceEmpty } from '@lhb/func';
import cs from 'classnames';
import styles from './index.module.less';
// import Card from './Card';

const ListItem:FC<{
  item: any;
  // curDetail: any;
  setCurDetail: any;
  setDetailDrawerData: (val: any) => void;
  shareParams?: any;
  allowSurroundTitleJumpDetail?: boolean;
}> = ({
  item,
  // curDetail,
  setCurDetail,
  shareParams,
  setDetailDrawerData,
  allowSurroundTitleJumpDetail
}) => {
  // console.log(`curDetail`, curDetail);

  const targetDailyFlow = useMemo(() => {
    return isNotEmpty(item?.dailyFlow) ? beautifyTheLowHighObject(1, item.dailyFlow, 1, { low: '人次', high: '万人次', top: '亿人次' }) : {};
  }, [item?.dailyFlow]);
  const targetWeekdayDailyFlow = useMemo(() => {
    return isNotEmpty(item?.weekdayDailyFlow) ? beautifyTheLowHighObject(1, item.weekdayDailyFlow, 1, { low: '人次', high: '万人次', top: '亿人次' }) : {};
  }, [item?.weekdayDailyFlow]);
  const targetWeekendDailyFlow = useMemo(() => {
    return isNotEmpty(item?.weekendDailyFlow) ? beautifyTheLowHighObject(1, item.weekendDailyFlow, 1, { low: '人次', high: '万人次', top: '亿人次' }) : {};
  }, [item?.weekendDailyFlow]);
  // 商业面积
  const commercialVolume = useMemo(() => {
    if (isNotEmpty(item.commercialVolume)) {
      return beautifyTheLowHighObject(1, item.commercialVolume, 1, { low: '㎡', high: '万㎡' });
    }
    return null;
  }, [item?.commercialVolume]);
  // 都没数据时，不显示
  const showCardGroup = useMemo(() => {
    return isNotEmptyAny(targetDailyFlow) || isNotEmptyAny(targetWeekdayDailyFlow) || isNotEmptyAny(targetWeekendDailyFlow);
  }, [targetDailyFlow, targetWeekdayDailyFlow, targetWeekendDailyFlow]);
  return <div
    className={styles.listItemCon}
    onClick={() => setCurDetail(item)}
  >
    <div>
      <span
        className={cs(styles.titCon, 'c-222 fs-14 ff-medium font-weight-500')}
        onClick={() => {
          if (!allowSurroundTitleJumpDetail) return;
          // 分享时不能打开
          if (shareParams && Object.keys(shareParams)?.length) return;
          setDetailDrawerData({
            open: true,
            id: item.id,
          });
        }}>
        {item.name}
      </span>

      {/* 1-已开业 2-待开业 */}
      {
        item.openingStatus === 2 ? <span className='fs-12 c-ff8'>（待开业）</span> : <></>
      }
    </div>
    <Row className='mt-4 c-666 fs-12'>
      <Col span={8}>
        开业时间：{item?.openingTime || '-'}
      </Col>
      <Col span={8}>
        商业面积：{isNotEmpty(commercialVolume) ? `${commercialVolume.val}${commercialVolume.unit}` : '-'}
      </Col>
    </Row>
    <Row gutter={9} className={cs('mt-8', showCardGroup ? '' : 'hide')}>
      <Col span={8}>
        <div className={styles.cardItemCon}>
          <div className={styles.imgCon}>
            <img
              src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_area_info_1@2x.png`}
              width='100%'
              height='100%'/>
          </div>
          <div className='pl-6 c-222'>
            <div>
              <span className='fs-16 bold ff-number-bold'>{replaceEmpty(targetDailyFlow?.val)}</span>
              <span className='fs-12'>{isNotEmpty(targetDailyFlow?.val) ? targetDailyFlow?.unit : ''}</span>
            </div>
            <div className='c-666 fs-12'>
              {isNotEmpty(item?.month) ? `${item.month}月` : ''}日均客流
            </div>
          </div>
        </div>
      </Col>
      <Col span={8}>
        <div className={styles.cardItemCon}>
          <div className={styles.imgCon}>
            <img
              src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_area_info_2@2x.png`}
              width='100%'
              height='100%'/>
          </div>
          <div className='pl-6 c-222'>
            <div>
              <span className='fs-16 bold ff-number-bold'>{replaceEmpty(targetWeekdayDailyFlow?.val)}</span>
              <span className='fs-12'>{isNotEmpty(targetWeekdayDailyFlow?.val) ? targetWeekdayDailyFlow?.unit : ''}</span>
            </div>
            <div className='c-666 fs-12'>
              工作日日均客流
            </div>
          </div>
        </div>
      </Col>
      <Col span={8}>
        <div className={styles.cardItemCon}>
          <div className={styles.imgCon}>
            <img
              src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_area_info_3@2x.png`}
              width='100%'
              height='100%'/>
          </div>
          <div className='pl-6 c-222'>
            <div>
              <span className='fs-16 bold ff-number-bold'>{replaceEmpty(targetWeekendDailyFlow?.val)}</span>
              <span className='fs-12'>{isNotEmpty(targetWeekendDailyFlow?.val) ? targetWeekendDailyFlow?.unit : ''}</span>
            </div>
            <div className='c-666 fs-12'>
              节假日日均客流
            </div>
          </div>
        </div>
      </Col>
    </Row>
    {/* </div>) */}
    {/* } */}
  </div>;
};


export default ListItem;
